const MINUTE = 60_000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;
const WEEK = 7 * DAY;

export function relativeTime(
  iso: string,
  locale: string,
  now: number = Date.now()
): string {
  const then = Date.parse(iso);
  if (Number.isNaN(then)) return iso;
  const diff = then - now;
  const rtf = new Intl.RelativeTimeFormat(locale, { numeric: "auto" });
  const abs = Math.abs(diff);
  if (abs < MINUTE) return rtf.format(0, "second");
  if (abs < HOUR) return rtf.format(Math.trunc(diff / MINUTE), "minute");
  if (abs < DAY) return rtf.format(Math.trunc(diff / HOUR), "hour");
  if (abs < WEEK) return rtf.format(Math.trunc(diff / DAY), "day");
  return rtf.format(Math.trunc(diff / WEEK), "week");
}
